import React, { useEffect, useState } from "react";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { useHistory } from "react-router";
import { GetShoppingCart } from "../../Api/BarestServices";
import BurgerMenuTitle from "../../Component/BurgerMenuTitle/BurgerMenuTitle";
import CompleteShopping from "../../Component/CompleteShopping/CompleteShopping";
import MenuBottom from "../../Component/menuBottom/MenuBottom";
import ShoppingBasket from "../../Component/ShoppingBasket/ShoppingBasket";
import Style from "./Shopping.module.css";
import { errorToast } from "../../Toast/Toast";
const Shopping = () => {
  const history = useHistory();
  const [update, setUpdate] = useState(false);
  const RerenderHandler = () => {
    GetCartList();
  };

  const [CartList, setCartList] = useState();
  useEffect(() => {
    GetCartList();
  }, []);
  const GetCartList = async () => {
    GetShoppingCart((succ,res)=>{
      if(succ){
        if(res.status==="0"){
          errorToast("مشکلی پیش آمده است")
        }else{
          setCartList(res.cart);
        }
      }else{
        console.error(res)
      }
    })
  };
  const setFinalize = () => {
    setUpdate(true);
    setTimeout(() => history.push("/finalizepurchase"), 600);
  };
  const cancelFinalize = () => {
    setUpdate(false);
  };
  let loadingHandler = null;
  let LoadingFinal = null;
  if (CartList === undefined) {
    loadingHandler = (
      <div className={Style.laodingStyle}>
        <PointSpreadLoading color={"#ab0c59"} size={"small"} />
      </div>
    );
    LoadingFinal = null;
  } else if (CartList.length === 0) {
    loadingHandler = (
      <div className={Style.noBuy}>
        <div className={Style.ImageBasket}>
          <img src="/Assets/Images/Order/not2.png" alt="برست" />
        </div>
        <h2 className={Style.emptyText}>سبد خرید شما خالی است</h2>
      </div>
    );
    LoadingFinal = null;
  } else {
    loadingHandler = CartList.map((item, index) => {
      return (
        <ShoppingBasket
          supID={item.supplier_id}
          sendDescription={update}
          rerenderForce={RerenderHandler}
          key={index}
          data={item}
          finalize={cancelFinalize}
        />
      );
    });
    LoadingFinal = (
      <>
        <CompleteShopping finalize={setFinalize} />
        <MenuBottom />
      </>
    );
  }

  return (
    <div className={Style.ShoppingHolder}>
      <BurgerMenuTitle title={"سبد خرید"} />
      <div className={Style.BasketHolder}>{loadingHandler}</div>
      {LoadingFinal}
      <MenuBottom />
    </div>
  )
}

export default Shopping